import { useStorage } from '~Components/Storage';
import { useSelector } from '~Hooks';

export default function useCheckPrinterImageSupport() {
  const [storage] = useStorage();
  const appVersion = useSelector((state) => state.appVersion);

  const checkImagePrintingSupported = (printerModel: string) => {
    if (!storage.useImagePrinting) {
      return false;
    }

    // This is the old Star library that does not support image printing
    if (printerModel.startsWith('MCP')) {
      return false;
    }

    // If it is epson or starcloud printer, we support image printing
    if (
      printerModel.startsWith('TM-') ||
      printerModel === 'EpsonSocket' ||
      printerModel === 'StarCloudPrinter'
    ) {
      return true;
    }

    // For DEV testing in browser purposes
    if (appVersion === 'browser') {
      return true;
    }

    const isSupportedStarPrinter =
      printerModel.startsWith('mC_') ||
      printerModel.toLowerCase() === 'stario' ||
      printerModel.toLowerCase() === 'starprint';

    // If the app version is 6.0.0 or higher and it is a supported Star printer
    if (appVersion >= '6.0.0' && isSupportedStarPrinter) {
      return true;
    }

    // Fallback to not supporting image printing
    return false;
  };

  return {
    checkImagePrintingSupported: checkImagePrintingSupported,
  };
}
